var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('copyable-field',{staticClass:"sub-block",attrs:{"is-loading":_vm.isLoading,"name":_vm.__('Reference'),"value":_vm.reference}})}
var staticRenderFns = []

export { render, staticRenderFns }